import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const MONTHS_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const DAYS_ES   = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];

let sermonsCache = null;

export default function SermonCalendar({ navigate }) {
  const today = new Date();
  const [year,  setYear]  = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [sermonDates, setSermonDates] = useState(sermonsCache || {});

  useEffect(() => {
    if (sermonsCache && Object.keys(sermonsCache).length > 0) return;
    const fetch = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'sermons'));
        const dates = {};
        snapshot.docs.forEach(d => { dates[d.id] = true; });
        if (Object.keys(dates).length > 0) {
          sermonsCache = dates;
          setSermonDates(dates);
        }
      } catch (e) { console.error(e); }
    };
    fetch();
  }, []);

  const firstDay    = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(y => y - 1); } else setMonth(m => m - 1); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(y => y + 1); } else setMonth(m => m + 1); };

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <>
      <h2 className="page-title">📖 Sermones</h2>

      <div className="card" style={{ padding: '20px 16px' }}>
        {/* Month nav */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <button onClick={prevMonth} style={navBtn}>‹</button>
          <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: '1rem' }}>
            {MONTHS_ES[month]} {year}
          </h3>
          <button onClick={nextMonth} style={navBtn}>›</button>
        </div>

        {/* Day headers */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4, marginBottom: 8 }}>
          {DAYS_ES.map(d => (
            <div key={d} style={{
              textAlign: 'center', fontSize: '0.7rem', fontWeight: 700,
              color: d === 'Dom' ? 'var(--navy)' : 'var(--text-sub)', padding: '4px 0',
            }}>{d}</div>
          ))}
        </div>

        {/* Calendar grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
          {cells.map((day, i) => {
            if (!day) return <div key={`e-${i}`} />;

            const isSunday  = (firstDay + day - 1) % 7 === 0;
            const dateKey   = `${year}-${String(month + 1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
            const hasSermon = !!sermonDates[dateKey];
            const isToday   = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();

            return (
              <div
                key={day}
                onClick={() => isSunday && hasSermon && navigate(`sermon-${dateKey}`)}
                style={{
                  textAlign: 'center', padding: '8px 2px', borderRadius: 10,
                  cursor: isSunday && hasSermon ? 'pointer' : 'default',
                  background: isToday ? 'var(--navy)' : hasSermon ? '#e8f0fe' : isSunday ? '#f5f7ff' : 'transparent',
                  border: hasSermon ? '2px solid var(--navy)' : '2px solid transparent',
                  transition: 'all 0.15s',
                }}
              >
                <div style={{
                  fontSize: '0.85rem', fontWeight: isSunday ? 800 : 400,
                  color: isToday ? 'white' : isSunday ? 'var(--navy)' : 'var(--text)',
                }}>{day}</div>
                {isSunday && hasSermon && (
                  <div style={{ fontSize: '0.55rem', color: 'var(--navy)', fontWeight: 700, marginTop: 2 }}>VER</div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 8, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.78rem', color: 'var(--text-sub)' }}>
          <div style={{ width: 14, height: 14, borderRadius: 4, background: '#e8f0fe', border: '2px solid var(--navy)' }} />
          Sermón disponible
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.78rem', color: 'var(--text-sub)' }}>
          <div style={{ width: 14, height: 14, borderRadius: 4, background: 'var(--navy)' }} />
          Hoy
        </div>
      </div>
    </>
  );
}

const navBtn = {
  background: 'var(--surface)', border: '1.5px solid var(--border)',
  borderRadius: 8, width: 36, height: 36, fontSize: '1.2rem',
  cursor: 'pointer', color: 'var(--navy)', fontWeight: 700,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
};
